


















import { Component, Vue } from "vue-property-decorator";
import { ruleDetail } from "@/req/commonity";
import Loading from "@/components/circleLoading.vue";
@Component({
  components: {
    Loading,
  },
})
export default class Logout extends Vue {
  public data: any = { title: "" };
  public isIos = false;
  public loadingState = true;

  public created() {
    this.isIos = (window as any).mb === "ios" ? true : false;
  }

  public async mounted() {
    const obj: any = this.$route.query;
    const moduleId = obj.module_id ? obj.module_id : "";
    const id = obj.id ? obj.id : "";
    this.getRuleDetail(moduleId, id);
  }

  public async getRuleDetail(moduleId, id) {
    const res = await ruleDetail({
      module_id: moduleId,
      id,
    });
    if (res.code == 200) {
      if (res.data.list.length) this.data = res.data.list[0];
    }
    const thah = this;
    setTimeout(() => {
      thah.loadingState = false;
    }, 700);
  }

  public onNavClick() {
    this.$router.go(-1);
  }
}
